import React, { Component } from 'react';
import Isvg from 'react-inlinesvg';

import BackButton from '../lib/BackButton';
import { PARTIES } from '../lib/lookup-tables';
import '../../scss/DistrictDetail.scss';

import { sortRaces } from '../lib/sorting';

function makeButton(race) {
  return (
    <li key={race.seat}>
      <button className="DistrictDetail__issue" onClick={() => this.props.route({route: 'race', race, raceLabel: race.seat})}>
        {race.seat}
      </button>
    </li>
  );
}

function hasCompetitiveRaces(races, party) {
  return !!_.flatten(Object.keys(races)
    .map(k => _.filter(races[k].candidates, { party })))
    .length;
}

export default class DisctrictDetail extends Component {
  
  render() {
    let { party } = this.props;
    let localRaces = sortRaces(this.props);

    return (
      <div className="DistrictDetail">
        <BackButton route='index' party={party} routeTo={this.props.route} />
        {hasCompetitiveRaces(localRaces, party) ? 
          <div>
            <h2 className="DistrictDetail__header">
              {PARTIES[party]}{party === 'G' && ' Party'} Primaries in District {this.props.district}
            </h2>
        
            <h3 className="DistrictDetail__subhead">Choose a Race</h3>
            <ul className="DistrictDetail__issues">
            {localRaces.map(makeButton.bind(this))}
            </ul>
          </div>
          :
          <h3 className="DistrictDetail__subhead">
            There are no citywide, boroughwide or City Council {PARTIES[party]}{party === 'G' && ' Party'} primaries in your district.
          </h3>}

          <a href="https://nyc.pollsitelocator.com/search" className="DistrictDetail__pollsite" target="_blank" rel="noopener noreferrer">
            <Isvg src="assets/images/icons/location.svg" className="location-icon" />
            You may have additional local races on your ballot. Click here for a sample ballot and to confirm your poll site.
          </a>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/src/js/routes/DistrictDetail.js